import { UPDATE_FILTERS_EVENT } from '../filters'

const HOTELS_INFO_WITH_FILTERING_SELECTOR = '.js-hotels-info-with-filtering'
const OFFER_HIGHLIGHT_SELECTOR = '.js-offer-highlight'

export function init() {
  const block = document.querySelector(HOTELS_INFO_WITH_FILTERING_SELECTOR)
  const highlights = document.querySelectorAll(OFFER_HIGHLIGHT_SELECTOR)

  block?.addEventListener(UPDATE_FILTERS_EVENT, () => {
    const filters = document.querySelectorAll('.js-filters-sidebar .js-filter .checked[data-offer-id]')

    highlights.forEach(highlight => highlight.classList.remove('offer-highlight--visible'))

    if (filters.length === 1) {
      const offerId = filters[0].dataset.offerId

      document.querySelector(`.js-offer-highlight[data-offer-id="${offerId}"]`).classList.add('offer-highlight--visible')
    }
  })
}
